import { atom, atomFamily, selectorFamily } from "recoil";
import ACOS from "../components/crosssection/contents/ACOS";
import ModelLFM from "../components/crosssection/contents/ModelLFM";
import ModelMSM from "../components/crosssection/contents/ModelMSM";
import csContentsPresetEffect from "./effect/CsContentsPresetEffect";
import Elevation from "../components/crosssection/contents/Elevation";
import ModelGSM from "../components/crosssection/contents/ModelGSM";
import ModelGFS from "../components/crosssection/contents/ModelGFS";

export const CS_SETTINGS = {
  [ACOS.CS_NAME]: {
    ftAll: false
  },
  [ModelLFM.CS_NAME]: {
    [ModelLFM.LFM_WIND]: false,
    [ModelLFM.LFM_ISOTACH]: true,
    [ModelLFM.LFM_ISOTHERM]: true,
    [ModelLFM.LFM_EQV_PT]: true,
    [ModelLFM.LFM_TMINUS_TD]: true,
    [ModelLFM.LFM_VWS]: true,
    [ModelLFM.LFM_ICING_PROB]: true
  },
  [ModelMSM.CS_NAME]: {
    [ModelMSM.MSM_WIND]: false,
    [ModelMSM.MSM_ISOTACH]: true,
    [ModelMSM.MSM_ISOTHERM]: true,
    [ModelMSM.MSM_EQV_PT]: true,
    [ModelMSM.MSM_TMINUS_TD]: true,
    [ModelMSM.MSM_VWS]: true,
    [ModelMSM.MSM_ICING_PROB]: true
  },
  [ModelGSM.CS_NAME]: {
    [ModelGSM.GSM_WIND]: false,
    [ModelGSM.GSM_ISOTACH]: true,
    [ModelGSM.GSM_ISOTHERM]: true,
    [ModelGSM.GSM_EQV_PT]: true,
    [ModelGSM.GSM_TMINUS_TD]: true,
    [ModelGSM.GSM_VWS]: true,
    [ModelGSM.GSM_ICING_PROB]: true
  },
  [ModelGFS.CS_NAME]: {
    [ModelGFS.GFS_WIND]: false,
    [ModelGFS.GFS_ISOTACH]: true,
    [ModelGFS.GFS_ISOTHERM]: true,
    [ModelGFS.GFS_EQV_PT]: true,
    [ModelGFS.GFS_TMINUS_TD]: true,
    [ModelGFS.GFS_VWS]: true,
    [ModelGFS.GFS_ICING_PROB]: true
  },
  [Elevation.CS_NAME]: {
    [Elevation.ELEVATION_ELEVATION]: true,
    [Elevation.ELEVATION_TERRAIN_ELEVATION]: true
  }
}

const csSettingStateFamily = atomFamily({
  key: 'csSettingStateFamily',
  default: selectorFamily({
    key: 'csSettingStateFamilySelector',
    get: param => () => {
      return CS_SETTINGS[param];
    }
  }),
  effects: param => [
    csContentsPresetEffect(param)
  ]
});

export const csChangeSettingWithId = selectorFamily({
  key: 'csChangeSettingWithId',
  get: (id) => ({get}) => {
    return get(csSettingStateFamily(id));
  },
  set: (id) => ({set, get}, setting) => {
    set(csSettingStateFamily(id), setting);
    const settings = get(csSettingState);
    const newSettings = {...settings, ...{[id]: setting}};
    set(csSettingState, newSettings);
  }
});

export const csSettingState = atom({
  key: 'csSettingState',
  default: CS_SETTINGS
});

export const csGradationState = atom({
  key: 'csGradationState',
  default: false
});
